// extracted by mini-css-extract-plugin
module.exports = {"select":"DriverForm_select__2TQKf","dropzoneSection":"DriverForm_dropzoneSection__1m4NM"};